module.exports = __webpack_public_path__ + "img/9788958072775.ad68b31b.jpg";